import React from 'react';
import Button from './../components/button';
//import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../util/inhomeUtils';
import { getUnsupportedProductById } from './../util/cartUtility';
import { ModalWindow, PAGEACTIVITY } from './actionType';
import * as buildProductAction from './../action/buildProduct'
import * as modalAction from './../action/modalWindow';
import { logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { updateSCTags } from './../service/dtmTag';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Title, Micro } from '@vds/typography';

class unsupportedProds extends React.PureComponent {
    constructor(props){
        super(props);
        this.state ={
            selectedCheckboxes : []
        }
    }

    buildSCContent = () => {
        let simplePageName = "byob";
        let detailPageName = "";

        try {
            let linkTag = "smart cart offline products removal overlay";
            detailPageName = " smart cart offline products removal overlay";
            detailPageName = `${simplePageName}| ${detailPageName}`;
        
            updateSCTags(linkTag);
        }
        catch (ex) {
            catchJSException('unsupportedProds', this.props.visitId, 'buildSCContent', ex);
        }
        
        return detailPageName;
    }

    onCloseModal = (e) => {
        modalAction.closeModalWindow(ModalWindow.ids.unSupportedDetails, this.props.dispatch);
    }

    componentWillMount=()=>{
        buildProductAction.errorMsgRemoveService(false, this.props.dispatch);
    }
    onUnsupportedSelect = (e, servType) => {
        try {
            this.setState((prevState) => {
                const {selectedCheckboxes} = prevState;
                if(selectedCheckboxes.includes(e.target.id + '~' + servType)){
                    return { selectedCheckboxes : selectedCheckboxes.filter((item) => item !== e.target.id + '~' + servType),};
                }else{
                    return { selectedCheckboxes : [...selectedCheckboxes,e.target.id + '~' + servType]}
                }
            })
        }
        catch (ex) {
            catchJSException('unsupportedProds', this.props.visitId, 'onUnsupportedSelect', ex);
        }
    }

    // onUnsupportedSelect = (e, servType) => { 
               
    //     try {
    //         if (this.selectedCheckboxes.has(e.target.id + '~' + servType)) {
    //             this.selectedCheckboxes.delete(e.target.id + '~' + servType);
    //         } else {
    //             this.selectedCheckboxes.add(e.target.id + '~' + servType);
    //         }
    //     }
    //     catch (ex) {
    //         catchJSException('unsupportedProds', this.props.visitId, 'onUnsupportedSelect', ex);
    //     }
    // }
    
    onUnsupportedRemoveClick = (event, selectedProducts, productList) => {
        try {
            event.preventDefault;
            let nonProdIdsData = []; let prodIdsData = ''; let productTypesData = '';
            let nonProdIdsVideo = []; let prodIdsVideo = ''; let productTypesVideo = '';
            let nonProdIdsVoice = []; let prodIdsVoice = ''; let productTypesVoice = '';
            let nonProdIdsVAS = []; let prodIdsVas = ''; let productTypesVas = ''; 
            let removedProductsIds = [];
            let nonProdIds = [];
            let productsToRemoveCount = 0;
            
            selectedProducts.forEach(prod => {
                if (InHomeUtils.isNotNull(prod)) {
                    let arrProd = prod.split('~'); 
                    productsToRemoveCount++;
                    nonProdIds.push(arrProd[0]);
                    
                    let product = getUnsupportedProductById(`${arrProd[0]}`, productList, this.props.visitId);
                    if (InHomeUtils.isNotNull(product) && arrProd.length > 1 && InHomeUtils.isNotEmpty(arrProd[1])) {
                        if (arrProd[1] === "DATA") {
                            if(product.prodType === "PPP"){
                                nonProdIdsVAS.push(arrProd[0]);
                                prodIdsVas += product.prodId + ':remove,'
                                productTypesVas += product.prodType + ','
                            }else{
                                nonProdIdsData.push(arrProd[0]);
                                prodIdsData += product.prodId + ':remove,'
                                productTypesData += product.prodType + ','
                            }
                        }
                        else if (arrProd[1] === "TV") {
                            nonProdIdsVideo.push(arrProd[0]);
                            prodIdsVideo += product.prodId + ':remove,'
                            productTypesVideo += product.prodType + ','
                        }
                        else if (arrProd[1] === "VOICE") {
                            nonProdIdsVoice.push(arrProd[0]);
                            prodIdsVoice += product.prodId + ':remove,'
                            productTypesVoice += product.prodType + ','
                        }
                    }
                }
            });

            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.visitId, 'UnSupportedProducts', "UNSUPPORTED-REMOVED", PAGEACTIVITY.UA));
            if(productsToRemoveCount > 0){
                let isMnHAuthenticated = ""
                if(this.props?.buildProductState?.internet?.mnhSignupIndicator !== "" && this.props?.buildProductState?.internet?.mnhSignupIndicator !== null && this.props?.buildProductState?.internet?.mnhSignupIndicator !== undefined){
                    isMnHAuthenticated = this.props?.buildProductState?.internet?.mnhSignupIndicator
                  }
                buildProductAction.errorMsgRemoveService(false, this.props.dispatch);
                if(prodIdsData !== ''){
                    nonProdIdsData.forEach(item => {
                        removedProductsIds.push(item)
                    });
                    let requestData = { contract: 'MTM', productId: prodIdsData, productType: productTypesData, quantity: '1', serviceType: 'DATA', status: 'remove',isMnHAuthenticated:isMnHAuthenticated }
                    buildProductAction.removeNonSupportedProducts(this.props.dispatch, this.props.visitId, requestData, nonProdIdsData, this.props.buildProductState.nonSupportedProduct, removedProductsIds,this.props.flowType);
                }
    
                if(prodIdsVas !== ''){
                    nonProdIdsVAS.forEach(item => {
                        removedProductsIds.push(item)
                    });
                    
                    let requestVAS = { contract: 'MTM', productId: prodIdsVas, productType: productTypesVas, quantity: '1', serviceType: 'VAS', status: 'remove',isMnHAuthenticated:isMnHAuthenticated }
                    buildProductAction.removeNonSupportedProducts(this.props.dispatch, this.props.visitId, requestVAS, nonProdIdsVAS, this.props.buildProductState.nonSupportedProduct, removedProductsIds,this.props.flowType);
                }
    
                if(prodIdsVideo !== ''){
                    nonProdIdsVideo.forEach(item => {
                        removedProductsIds.push(item)
                    });
                    
                    let requestVideo = { contract: 'MTM', productId: prodIdsVideo, productType: productTypesVideo, quantity: '1', serviceType: 'VIDEO', status: 'remove',isMnHAuthenticated:isMnHAuthenticated }
                    buildProductAction.removeNonSupportedProducts(this.props.dispatch, this.props.visitId, requestVideo, nonProdIdsVideo, this.props.buildProductState.nonSupportedProduct, removedProductsIds,this.props.flowType,this.props.buildProductState);
                }
    
                if(prodIdsVoice !== ''){
                    nonProdIdsVoice.forEach(item => {
                        removedProductsIds.push(item)
                    });
                   
                   let requestVoice = { contract: 'MTM', productId: prodIdsVoice, productType: productTypesVoice, quantity: '1', serviceType: 'VOICE', status: 'remove',isMnHAuthenticated:isMnHAuthenticated }
                   buildProductAction.removeNonSupportedProducts(this.props.dispatch, this.props.visitId, requestVoice, nonProdIdsVoice, this.props.buildProductState.nonSupportedProduct, removedProductsIds,this.props.flowType);
                }
              
                if(productList.prodsCount === 0 || (productsToRemoveCount > 0 &&  productsToRemoveCount === productList.prodsCount)){
                    this.onCloseModal(ModalWindow.ids.unSupportedDetails)
                }
            }
            else{
                buildProductAction.errorMsgRemoveService(true, this.props.dispatch);
            }
        }
        catch (ex) {
            catchJSException('unsupportedProds', this.props.visitId, 'onUnsupportedRemoveClick', ex);
        }
    }

    render() {
        if (InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct.prodsCount) && this.props.buildProductState.nonSupportedProduct.prodsCount > 0) {
            this.selectedCheckboxes = new Set();
        }

        return (
            <div>
                {/* <div className="modal_header"><h5 className={( this.props.buildProductState.nonSupportedProduct.prodsCount > 0) ? "margin-top-zero" : "hide"}>Which Service do you want to remove?</h5></div>
                <div className="modal_content fixModalHeight"> */}
                <ModalTitle>
                    <div  className={( this.props.buildProductState.nonSupportedProduct.prodsCount > 0) ? "margin-top-zero" : "hide"}><Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h5" color="black">Which Service do you want to remove?</Title></div>                                       
                </ModalTitle>
                <ModalBody>
                <div className={this.props.buildProductState.errorMsgRemoveService ? "margin-horiz-small text-alert bold" : "hide"}>Please select any Service to be removed.</div>
                    <div className={this.props.buildProductState.nonSupportedProduct.dataProducts.length > 0 ? "margin-bottom-small" : "hide"} id="GetDataProd"  >
                        <p className="margin-bottom-micro bold text-black">Internet</p>
                        <ul className="margin-bottom-zero no-bullet" id="ulUnSupportedData">
                            {this.props.buildProductState.nonSupportedProduct.dataProducts.map((item, index) => (
                                <li key={'liData~' + item.id}>
                                    <input key={item.id+'~DATA'} id={item.id} type="checkbox" errorText="" className="value" name={"datachk_" + item.id}
                                        onClick={(e) => this.onUnsupportedSelect(e, "DATA")} />
                                    <label htmlFor={item.id} className="normal-weight">{item.description}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={this.props.buildProductState.nonSupportedProduct.tvProducts.length > 0 ? "margin-bottom-small" : "hide"} id="GetTVProd">
                        <p className="margin-bottom-micro bold text-black">TV</p>
                        <ul className="margin-bottom-zero no-bullet" id="ulUnSupportedTv">
                            {this.props.buildProductState.nonSupportedProduct.tvProducts.map((item, index) => (
                                <li key={'liTv~' + item.id}>
                                    <input key={item.id+'~TV'} id={item.id} type="checkbox" errorText="" className="value" name={"tvchk_" + item.id}
                                        onClick={(e) => this.onUnsupportedSelect(e, "TV")} />
                                    <label htmlFor={item.id} className="normal-weight">{item.description}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={this.props.buildProductState.nonSupportedProduct.voiceProducts.length > 0 ? "margin-bottom-small" : "hide"} id="GetVoiceProd">
                        <p className="margin-bottom-micro bold text-black">VOICE</p>
                        <ul className="margin-bottom-zero no-bullet" id="ulUnSupportedVoice">
                            {this.props.buildProductState.nonSupportedProduct.voiceProducts.map((item, index) => (
                                <li key={'liVoice~' + item.id}>
                                    <input key={item.id+'~VOICE'} id={item.id} type="checkbox" errorText="" className="value" name={"voicechk_" + item.id}
                                        onClick={(e) => this.onUnsupportedSelect(e, "VOICE")} />
                                    <label htmlFor={item.id} className="normal-weight">{item.description}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={( this.props.buildProductState.nonSupportedProduct.prodsCount > 0) ? "row" : "hide"}>
                        <div className="columns tiny-12 small-6 OwnRouterCancel_button">
                            <Button buttonText="Cancel" buttonStyle={"button secondary tiny-10 margin-top-tiny"} onClick={e => this.onCloseModal(e) } />
                        </div>
                        <div className="columns tiny-12 small-6 OwnRouterContinue_button">
                            <Button buttonText="Remove Service" buttonStyle={"button tiny-10 margin-top-tiny"} onClick={e => {this.onUnsupportedRemoveClick(e, this.state.selectedCheckboxes, this.props.buildProductState.nonSupportedProduct); this.buildSCContent()}} />
                        </div>
                    </div>
                {/* </div> */}</ModalBody>
            </div>
        )
    }
}
export default unsupportedProds;
